import classNames from 'classnames'
import { Link } from 'react-scroll'

import DropDown from 'components/DropDown'
import { useVersion } from 'hooks'

import styles from './Header.module.scss'

const NavItem = ({ title, Icon, link, index, isLink, setIsOpened, mainNavigation }: any) => {
  const { isEventPage } = useVersion()

  if (!isEventPage && mainNavigation) {
    return null
  }

  return isLink ? (
    <DropDown />
  ) : (
    <Link
      to={`${link}`}
      smooth={true}
      duration={500}
      className={styles.item__child}
      onClick={() => {
        setIsOpened(false)
      }}
    >
      <div
        className={classNames(styles.wrapper__content, {
          [styles.wrapper__content_active]: index === 0,
        })}
      >
        {title && <h3>{title}</h3>}

        {Icon && <Icon />}
      </div>
    </Link>
  )
}

export default NavItem
